<div *ngIf="!registerSuccess" class="d-flex justify-content-center h-100">
    <div class="col-lg-3">
        <form [formGroup]="form" class="text-center border border-primary p-4 mt-5 z-depth-2" (ngSubmit)="createUser()">

            <h2 class="text-center">Register account</h2>
            <div class="mb-4 mt-1">
                <mdb-icon fas icon="envelope"></mdb-icon>
                <input mdbInput formControlName="emailFormEx" minLength="5" type="email" class="form-control" placeholder="E-mail">
                <span *ngIf="emailFormEx && !emailFormEx.valid && emailFormEx.dirty && emailFormEx.touched" class="text-danger">Please enter correct mail format</span>
            </div>

            <div class="mb-4 mt-1">
                <mdb-icon fas icon="user"></mdb-icon>
                <input mdbInput value="" formControlName="name" type="name" id="form6" class="form-control" placeholder="Name" required mdbInput>
                <span *ngIf="nameForm && !nameForm.valid && nameForm.dirty && nameForm.touched" class="text-danger">Only A-Z characters allowed. No spaces</span>
            </div>

            <div class="mb-4 mt-1">
                <mdb-icon fas icon="key"></mdb-icon>
                <input mdbInput value="" formControlName="password" type="password" class="form-control" placeholder="Password" required mdbInput>
                <span *ngIf="passwordForm && !passwordForm.valid && passwordForm.dirty && passwordForm.touched" class="text-danger">Password must have at least 8 characters</span>
            </div>
            <div class="mb-4 mt-1">
                <mdb-icon fas icon="globe-africa"></mdb-icon>
                <select formControlName="country" class="browser-default custom-select">
                <option value="" disabled selected hidden>Choose your country</option>
                <option *ngFor="let c of countries" [value]="c.value">{{c.text}}</option>
              </select>
            </div>
            <div class="mb-4 w-100">
                <mdb-checkbox formControlName="policy" [default]="true">I agree to <a href="/policy" target="_blank">privacy policy</a></mdb-checkbox>
            </div>
            <div>
                <gb-action-button [isLoading]="registerLoading" [whenDisabled]="!form.valid" [text]="'Register'" [iconClass]="'sign-in-alt'"></gb-action-button>
            </div>
        </form>
    </div>
</div>

<div *ngIf="registerSuccess" class="d-flex justify-content-center h-100">
    <div class="col-sm-3 text-center border border-primary p-4 mt-5 z-depth-2">
        <h1 class="mb-5">Success!</h1>
        <h5 class="mb-2">We have sent activation mail to:</h5>
        <h3><b>{{emailSuccess}}</b></h3>
        <h5 class="mt-2 mb-5">Please visit your inbox and click on activation link</h5>
        <a href="/login">Go to login</a>
    </div>
</div>
